import { Report, ReportsResponse } from './interface'
import { API } from '@/services/api-onix'

export const fetchAll = async (
  filtros: Record<string, any>
): Promise<{
  items: Report[]
  total: number
}> => {
  try {
    const response = await API.post<ReportsResponse>(
      '/Relatorios/ObterRelatoriosGerados',
      filtros,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    const results: Report[] = response.conteudo.solicitacoesDeRelatorios ?? []

    const total = response.conteudo.quantidadeSolicitacoesDeRelatorios ?? 0
    return { items: results, total }
  } catch (error) {
    console.error('Erro ao buscar relatorios:', error)
    return { items: [], total: 0 }
  }
}
